import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

import { formatCharterFeederDirection } from '../CharterFeederPricesHelpers';
import type { CharterFeederSheetRow } from '../CharterFeederPricesTypes';

import { formatDateLabel } from './DateCell';

interface DeleteRowDialogProps {
  row: CharterFeederSheetRow | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function DeleteRowDialog({ row, onCancel, onConfirm }: DeleteRowDialogProps): React.JSX.Element {
  const summary = row ? `${formatDateLabel(row.date)} · ${formatCharterFeederDirection(row)}` : '';

  return (
    <Dialog open={Boolean(row)} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle>Clear route values?</DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <Typography variant="body2">
            This blanks all feeder base and buffer values for this route/date in the draft. The row will remain visible.
          </Typography>
          {row && (
            <Typography variant="subtitle2" fontWeight={600}>
              {summary}
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="text">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          Clear values
        </Button>
      </DialogActions>
    </Dialog>
  );
}
